import { apiClient } from "../../../services/apiClient";

interface NotePayload {
  title: string;
  note: string;
  employeeNotesCategoryId: string;
}

export interface IEmployeeNote {
  id: string;
  name: string;
}

export async function createEmployeeNote(
  employeeId: string,
  subject: string,
  message: string,
  categoryId: string
) {
  if (!employeeId) throw new Error("EmployeeId é obrigatório");

  const payload: NotePayload = {
    title: subject,
    note: message,
    employeeNotesCategoryId: categoryId,
  };

  try {
    const { data } = await apiClient.post(
      `/employees/${employeeId}/notes`,
      payload
    );
    return data;
  } catch (err: any) {
    throw new Error(
      err.response?.data?.message || `Falha ao criar nota: ${err}`
    );
  }
}

export async function getEmployeeNotesCategory(): Promise<IEmployeeNote[]> {
  const { data } = await apiClient.get<IEmployeeNote[]>(
    "/employees/notes/categories"
  );
  return data;
}

export async function updateEmployeeNote(
  employeeId: string,
  noteId: string,
  subject: string,
  message: string,
  categoryId: string
) {
  if (!employeeId || !noteId) throw new Error("EmployeeId e NoteId são obrigatórios");

  const payload: NotePayload = {
    title: subject,
    note: message,
    employeeNotesCategoryId: categoryId,
  };

  try {
    const { data } = await apiClient.put(
      `/employees/${employeeId}/notes/${noteId}`,
      payload
    );
    return data;
  } catch (err: any) {
    throw new Error(
      err.response?.data?.message || `Falha ao atualizar nota: ${err}`
    );
  }
}


export async function deleteEmployeeNote(employeeId: string, noteId: string) {
  if (!employeeId || !noteId) throw new Error("EmployeeId e NoteId são obrigatórios");

  try {
    const { data } = await apiClient.delete(
      `/employees/${employeeId}/notes/${noteId}`
    );
    return data;
  } catch (err: any) {
    throw new Error(
      err.response?.data?.message || `Falha ao eliminar nota: ${err}`
    );
  }
}